import Icon from './src/Icon.vue';
import SvgIcon from './src/SvgIcon.vue';
import IconPicker from './src/IconPicker.vue';

export { Icon, IconPicker, SvgIcon };

export default Icon;
